import deploymentUrls from "../envs/deploymentConfigs";
import { azureADConfigsDEV, azureADConfigsPROD, azureADConfigsTEST, tokenClaimScope } from "./environmentConfigs";

let configurations;
let appRegScope;

const clientUrl = deploymentUrls.client;

if(process.env.REACT_APP_ENV === "developmentenv" || process.env.REACT_APP_ENV === "development" ){
    configurations = azureADConfigsDEV;
    appRegScope = tokenClaimScope.devEnvScope;
}

else if(process.env.REACT_APP_ENV === "test"){
    configurations = azureADConfigsTEST;
    appRegScope = tokenClaimScope.testEnvScope;
}

else if(process.env.REACT_APP_ENV === "production"){
    configurations = azureADConfigsPROD;
    appRegScope = tokenClaimScope.prodEnvScop;
}
else{
    configurations = azureADConfigsDEV;
    appRegScope = tokenClaimScope.devEnvScope;
}

export const msalConfig = {
    auth: {
        clientId:  configurations.clientId,
        authority: configurations.authority, 
        tenantId: configurations.tenantId,
      postLogoutRedirectUri: clientUrl,
      redirectUri: clientUrl,
    },
    cache: {
      cacheLocation: process.env.REACT_APP_MSAL_CACHE || "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      iframeHashTimeout: 10000,
      allowNativeBroker: false,
      loggerOptions: {
        loggerCallback: () => {},
        piiLoggingEnabled: false,
        logLevel: 1,
      }
    }
  };
  
  export const loginRequest = {
    scopes: ["openid", "profile", "User.Read"]
  };
  
  export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

export const apiScopeConfig = {
    apiScope: appRegScope
}